import { useState } from "react";
import type { GameState } from "../api";
import { shareText } from "../game/share";
import { closeApp, colorScheme, haptic } from "../telegram";
import { Stats } from "./Stats";

const WIN_LINES = ["Геній", "Чудово", "Вражає", "Файно", "Є", "Фух"];

export function ResultSheet({ state, onDismiss }: { state: GameState; onDismiss: () => void }) {
  const [copied, setCopied] = useState(false);
  const won = state.status === "won";
  const attempts = state.guesses.length;
  const title = won ? (WIN_LINES[attempts - 1] ?? "Є") : "Не сьогодні";
  const subtitle = won
    ? `${attempts}/6 · стрік ${state.me.streak} 🔥`
    : `слово було ${state.solution?.toUpperCase() ?? "?"} · стрік згорів`;

  const others = state.group.filter((g) => g.status !== "playing");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(
        shareText(state.number, state.guesses, won, colorScheme() === "dark"),
      );
      setCopied(true);
      haptic.success();
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard may be unavailable inside some WebViews — silently ignore
    }
  };

  return (
    <div className="fixed inset-0 z-30 flex items-end justify-center bg-black/50" onClick={onDismiss}>
      <div
        className="sheet max-h-[88vh] w-full max-w-[520px] overflow-y-auto rounded-t-2xl bg-tgsection px-5 pb-[calc(env(safe-area-inset-bottom)+20px)] pt-3 text-tgtext shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-tghint/40" />
        <div className="text-center">
          <div className="text-2xl font-bold">{title}</div>
          <div className="mt-1 text-sm text-tghint">{subtitle}</div>
        </div>

        <div className="mt-5">
          <Stats me={state.me} highlight={won ? attempts : null} />
        </div>

        {others.length > 0 && (
          <div className="mt-5">
            <div className="text-xs font-semibold uppercase tracking-wide text-tghint">сьогодні в чаті</div>
            <ul className="mt-2 divide-y divide-tghint/15 text-sm">
              {others.map((g) => (
                <li key={g.userId} className="flex items-center justify-between py-1.5">
                  <span className="font-medium">{g.name}</span>
                  <span className="text-tghint">
                    {g.status === "won" ? `${g.attempts}/6` : "X/6"}
                    {g.streak > 0 ? ` · 🔥${g.streak}` : ""}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mt-5 text-center text-xs text-tghint">чіпс уже несе результат у чат</div>

        <div className="mt-3 grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={copy}
            className="rounded-xl bg-tghint/20 py-3 text-sm font-semibold active:opacity-70"
          >
            {copied ? "скопійовано ✓" : "копіювати сітку"}
          </button>
          <button
            type="button"
            onClick={closeApp}
            className="rounded-xl bg-tgbutton py-3 text-sm font-semibold text-tgbuttontext active:opacity-80"
          >
            назад у чат
          </button>
        </div>
      </div>
    </div>
  );
}
